import { create, StoreApi, UseBoundStore } from "zustand";

type AtomStore<T> = {
    value: T;
};

type Atom<T> = UseBoundStore<StoreApi<AtomStore<T>>> & { update: (fn: (prev: T) => T) => void; set: (next: T) => void };

export function createAtom<T = undefined>(): Atom<T | undefined>;
export function createAtom<T>(initialValue: T): Atom<T>;

export function createAtom<T>(initialValue?: T) {
    const atom$ = create<AtomStore<T | undefined>>()(() => ({
        value: initialValue,
    }));

    return Object.assign(atom$, {
        update(fn: (prev: T) => T) {
            const prev = atom$.getState().value;
            const next = fn(prev as T);
            atom$.setState({ value: next });
        },
        set(next: T) {
            atom$.setState({ value: next });
        },
    });
}
